module.exports = __webpack_public_path__ + "static/media/darthvader.7d217ea1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionOne/illus/darthvader.svg
// module id = 149
// module chunks = 0